/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { elasticSearchMetaSchema } from './elastic-search-meta';
import { opportunityInterviewResultDtoSchema } from './opportunity-interview-result-dto';

/** ReadOpportunitiesInterviewsResponse — dark-roast DTO: OpportunityInterviewsSearchResponseDto; also used by readUsersOpportunitiesInterviews */
export const readOpportunitiesInterviewsResponseSchema = z.object({ "data": z.array(z.lazy(() => opportunityInterviewResultDtoSchema)), "meta": z.lazy(() => elasticSearchMetaSchema).nullish() });
export type ReadOpportunitiesInterviewsResponse = z.infer<typeof readOpportunitiesInterviewsResponseSchema>;
